export enum JobDtoType {
  ContentHubBulkImport = 'ContentHubBulkImport',
}
